import { CarrierVisitDto, VesselReportContainerEntry, VesselSummaryDto } from '@billing/app/api'
import exportService from '@billing/services/ExportService'
import { CarrierVisitStore } from '@billing/stores/CarrierVisitStore'
import _ from 'lodash'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'
import { VesselReportTotalSummary } from '../models/vessel-report-total-summary.model'

export class VesselReportUIStore {
  selectedVesselVisitId?: number | string = ''
  vesselSummary?: VesselSummaryDto

  vesselContainers: VesselReportContainerEntry[] = []
  isLoading = false
  handleDownload?: () => void

  constructor(private carrierVisitStore: CarrierVisitStore) {
    makeObservable(this, {
      selectedVesselVisitId: observable,
      vesselSummary: observable,
      vesselContainers: observable,
      isLoading: observable,

      vesselVisitsOptions: computed,
      vesselSummaryMetrics: computed,

      setSelectedVesselVisitId: action,
      setVesselSummary: action,
      fetchVesselData: action,
      resetData: action,
      setHandleDownload: action,
    })
  }

  public get vesselVisitsOptions(): CarrierVisitDto[] {
    return _(this.carrierVisitStore.items)
      .sortBy(wq => wq.ata)
      .value()
  }

  public get vesselSummaryMetrics(): VesselReportTotalSummary {
    const totalDischarge = _.sumBy(this.vesselSummary?.discharge, x => x.amount),
      totalLoad = _.sumBy(this.vesselSummary?.load, x => x.amount),
      totalRestow = _.sumBy(this.vesselSummary?.restow, x => x.amount)

    return {
      total: totalDischarge + totalLoad + totalRestow,
      discharge: totalDischarge,
      load: totalLoad,
      restow: totalRestow,
    }
  }

  setSelectedVesselVisitId(id?: number): void {
    this.selectedVesselVisitId = id
  }

  setVesselSummary(dto?: VesselSummaryDto): void {
    this.vesselSummary = dto
  }

  setHandleDownload(action: () => void) {
    this.handleDownload = action
  }

  async fetchVesselData(): Promise<void> {
    if (!this.selectedVesselVisitId) return
    this.isLoading = true
    try {
      const data = await exportService.getVesselData(+this.selectedVesselVisitId)
      runInAction(() => {
        this.vesselContainers = data
      })
    } catch (error) {
      console.error('Error fetching vessel data:', error)
    } finally {
      runInAction(() => {
        this.isLoading = false
      })
    }
  }

  public getVoyageDisplay(carrierVisitDto: CarrierVisitDto): string {
    return `${carrierVisitDto.importVoyage ? carrierVisitDto.importVoyage : '-'} / ${
      carrierVisitDto.exportVoyage ? carrierVisitDto.exportVoyage : '-'
    }`
  }

  public resetData(): void {
    this.setSelectedVesselVisitId()
    this.setVesselSummary()
    this.vesselContainers = []
    this.isLoading = false
  }
}
